"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemVanityClasses = void 0;
const Class_1 = require("../classes/Class");
const definables_1 = require("definables");
const getItemVanityClassIDs_1 = require("./getItemVanityClassIDs");
const getItemVanityClasses = (itemID) => (0, getItemVanityClassIDs_1.getItemVanityClassIDs)(itemID).map((classID) => (0, definables_1.getDefinable)(Class_1.Class, classID));
exports.getItemVanityClasses = getItemVanityClasses;
